<script>
  export let startScan;
  export let currentPhotoData = { title: "" };
  export let colorClass = "bg-white";
</script>

<div
  class="{colorClass} w-100 absolute bottom-0 left-0 flex justify-between pv2 ph2"
>
  <p class="ml3">{currentPhotoData.title}</p>
</div>

<style>
  button,
  button img {
    width: 48px;
    height: 48px;
    margin: 0;
    padding: 0;
  }
</style>
